module.exports = __webpack_public_path__ + "static/toby_s.0caa86d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/reviews/toby_s.png
// module id = 1719
// module chunks = 35783957827783